export default __webpack_public_path__ + "static/media/15.036f492f.png";